class RealProductBanner extends HTMLElement {
  #copyStatusTimer;

  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-discount-code-copy]');
    if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;

    this.#copyDiscountCode(button);
  };

  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
    this.querySelectorAll('[data-discount-code-status]').forEach((status) => {
      status.textContent = '';
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    window.clearTimeout(this.#copyStatusTimer);
  }

  /** @param {HTMLButtonElement} button */
  async #copyDiscountCode(button) {
    const discountCode = button.dataset.discountCode;
    if (!discountCode) return;

    const shouldRestoreFocus = document.activeElement === button;
    button.disabled = true;

    try {
      await this.#writeToClipboard(discountCode);
      this.#showCopyStatus(button, discountCode, button.dataset.copiedMessage || 'Copied');
    } catch (error) {
      console.warn('[real-product-banner] Failed to copy discount code:', error);
      this.#showCopyStatus(button, discountCode, button.dataset.copyErrorMessage || 'Unable to copy');
    } finally {
      button.disabled = false;
      if (shouldRestoreFocus && button.isConnected) button.focus({ preventScroll: true });
    }
  }

  /** @param {string} text */
  async #writeToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return;
      } catch {
        // Fall through for browsers that expose the Clipboard API but deny access.
      }
    }

    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();

    try {
      if (!document.execCommand('copy')) throw new Error('The copy command was rejected');
    } finally {
      textArea.remove();
    }
  }

  /**
   * @param {HTMLButtonElement} button
   * @param {string} discountCode
   * @param {string} message
   */
  #showCopyStatus(button, discountCode, message) {
    if (!button.isConnected || !this.contains(button) || button.dataset.discountCode !== discountCode) return;

    const row = button.closest('[data-discount-code-row]');
    const status = row?.querySelector('[data-discount-code-status]');
    if (!status) return;

    status.textContent = message;
    window.clearTimeout(this.#copyStatusTimer);
    this.#copyStatusTimer = window.setTimeout(() => {
      if (status.isConnected && this.contains(status)) status.textContent = '';
    }, 2500);
  }
}

if (!customElements.get('real-product-banner')) {
  customElements.define('real-product-banner', RealProductBanner);
}
